import { html } from 'lit';
const Web =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.784 11.25H8.26c.06-2.25.39-4.298.907-5.851.161-.483.345-.932.552-1.33a8.26 8.26 0 0 0-5.935 7.181m8.216-9c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m0 1.5c-.086 0-.287.052-.579.421-.285.362-.574.932-.83 1.702-.459 1.374-.77 3.255-.83 5.377h4.478c-.06-2.122-.371-4.003-.83-5.377-.256-.77-.545-1.34-.83-1.702-.292-.37-.493-.421-.579-.421m3.74 7.5c-.06-2.25-.39-4.298-.907-5.851a9 9 0 0 0-.552-1.33 8.26 8.26 0 0 1 5.935 7.181zm-1.5 1.5H9.76c.06 2.122.372 4.003.83 5.377.257.77.546 1.34.831 1.701.292.37.493.422.579.422s.287-.052.579-.422c.285-.361.574-.93.83-1.701.459-1.374.77-3.255.83-5.377m.041 7.18c.207-.397.39-.846.552-1.329.518-1.553.847-3.6.907-5.851h4.476a8.26 8.26 0 0 1-5.935 7.18m-4.562 0a9 9 0 0 1-.552-1.329c-.517-1.553-.847-3.6-.907-5.851H3.784a8.26 8.26 0 0 0 5.935 7.18" clip-rule="evenodd"/>
  </svg>
`;
export default Web;
